import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import { BASE_PATH } from '../../services/api-agendamento-relatorio'

export { BASE_PATH }
const crud = build(validate, BASE_PATH)
const prefix = 'crudAgendamentoRelatorio'

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types)

export { types, actions }
